import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_wor from '../../../axios-instance-wor';

/**
 * Obtener áreas.
 */
export async function fetchAreas({state, commit}, reset_page = false) {

    if (reset_page) {
        commit('resetPageParams');
    }

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('areas/' + state.params.company_id, {params: state.params})
        .then(async (response) => {
            commit('setAreas', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener área.
 */
export async function getArea({state, commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('areas/' + state.params.company_id + '/' + id,)
        .then(async (response) => {
            commit('setArea', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener última área.
 */
export async function getLastArea({state, commit}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('areas/last/' + state.params.company_id)
        .then(async (response) => {
            commit('setCodeToArea', response.data.data.code);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear área.
 */
export async function addArea({ state, commit }) {
    try {

        commit('dashboard/load', true, { root: true });

        const response = await $http_wor.post(
            'areas/' + state.params.company_id,
            state.area
        );

        commit('dashboard/load', false, { root: true });
        commit('setModalShow', false);

        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Muy bien!',
            text: response.data.message,
            showConfirmButton: false,
            timer: 2000,
        });

        return true;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: error.message || 'No se pudo agregar el área.',
            showConfirmButton: false,
            timer: 2000,
        });

        return false;
    }
}

/**
 * Actualizar área.
 */
export async function updateArea({ state, commit }) {
    try {

        commit('dashboard/load', true, { root: true });
        const response = await $http_wor.put(
            'areas/' + state.params.company_id + '/' + state.area.id,
            state.area
        );

        commit('dashboard/load', false, { root: true });
        commit('setModalShow', false);

        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Muy bien!',
            text: response.data.message,
            showConfirmButton: false,
            timer: 2000,
        });

        return true;
    } catch (error) {

        commit('dashboard/load', false, { root: true });
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error',
            text: error.message,
            showConfirmButton: false,
            timer: 2000,
        });

        return false;
    }
}


/**
 * Eliminar área.
 */
export async function deleteArea({ commit, state }, id) {
    const result = await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar el área?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, eliminar',
    });

    if (result.isConfirmed) {
        try {
            commit('dashboard/load', true, { root: true });
            const response = await $http_wor.delete('areas/' + state.params.company_id + '/' + id);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 2000,
            });

            commit('dashboard/load', false, { root: true });

            return true;
        } catch (error) {
            commit('dashboard/load', false, { root: true });

            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message || 'No se pudo eliminar el área.',
                showConfirmButton: true,
                timer: 5000,
            });

            return false;
        }
    }

    return false;
}

/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state, rootState}, filter) {

    if (!rootState.dashboard.loading && filter && filter.length > 2) {
        commit('dashboard/load', true, {root: true});

        let params = {
            nombre: filter
        };

        await $http.get('/empresas/lista', {params})
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Descargar plantilla
 */
export async function downloadTemplate({commit}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor({
        url: '/areas/download-template',
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla áreas.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Subir archivo y crear áreas masivamente.
 */
export async function uploadAndMassiveCreate({commit, state}) {
    let form_data = new FormData();

    for (let key in state.upload) {
        form_data.append(key, state.upload[key]);
    }

    commit('dashboard/load', true, {root: true});

    await $http_wor.post('/areas/massive-creation/' + state.params.company_id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            let errors = response.data.errors;

            if (errors.length) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'Existen inconsistencias en el archivo cargado',
                    showConfirmButton: false,
                    timer: 3000
                });

                errors.unshift({errores: 'errores'});
                let csv = '';
// Loop the array of objects
                for (let row = 0; row < errors.length; row++) {
                    let keysAmount = Object.keys(errors[row]).length;
                    let keysCounter = 0;

                    if (row === 0) {

                        for (let key in errors[row]) {

                            csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    } else {
                        for (let key in errors[row]) {
                            csv += errors[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    }

                    keysCounter = 0;
                }

                let link = document.createElement('a');
                link.id = 'download-csv';
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                link.setAttribute('download', 'errores.csv');
                document.body.appendChild(link);
                document.querySelector('#download-csv').click();
            } else {
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 2000
                });
            }
        })
        .catch((error) => {

            commit('dashboard/load', false, {root: true});

            console.error(error);

            Notification.error({
                title: 'Error',
                message: 'Error al procesar el archivo',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}

/**
 * Cargar las áreas padre, excluyendo la actual.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @param {*} id - Identificador del área actual.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function showAreaFather({ commit }, { company_id, id }) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.get(`areas-father/list/${company_id}`,
        {
            params: {
                id: id
            }
        });
        commit("setAreasFather", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}

/**
 * Cargar el árbol de áreas.
 *
 * @param {*} commit - Función de Vuex para llamar a una mutación.
 * @param {*} company_id - Identificador de la empresa.
 * @return {Promise<void>}
 * @author Brandon Torres
 */
export async function fetchAreasTree({ commit }, company_id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.get(`areas-father/tree/${company_id}`);
        commit("setAreasTree", response.data.data);
    } catch (error) {
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
